export default {
  dev: true,
  // NOTE: since the JWT auth rework the internal API is module-less - the host must NOT contain a /v1 suffix
  apiHost: process.env.REACT_APP_API_HOST, //"https://apigolive.culinarystaffing.com",
  webHost: process.env.REACT_APP_WEB_HOST, //"https://culinarystaffing.com",
  requestTimeout: 15000,
  auth: {
    url: "/user/login"
  }
};
